import React from 'react';

const MyProfile: React.FC = () => {
    return (
        <div>
            <h1>My Profile</h1>
            <p>Welcome to your profile page!</p>
        </div>
    );
};

export default MyProfile;